import React, { useState, useEffect } from "react";
import Markup from "./jsx";
import { withResizeDetector } from "react-resize-detector";
import "./css/style.css";
import ThemeContextProvider from "./context/ThemeContext";
import { useKeycloak } from "@react-keycloak/web";
import LoginErrorPage from "./jsx/pages/error/LoginErrorPage";
import NetworkError from "./jsx/pages/error/NetworkError";
import request from "./jsx/services/request";
import { Spinner } from "react-bootstrap";

const App = () => {
  const { keycloak, initialized } = useKeycloak();
  const [isSystemUser, setIsSystemUser] = useState(null);
  const [user, setUser] = useState(null);
  const checkUser = () => {
    if (!initialized)
      return;
    request({
      url: "user/control",
      method: "GET",
    })
      .then((res) => {
        if (res.responseStatus === "SUCCESS") {
          setIsSystemUser("systemUser");
          setUser(res.body);
        } else {
          setIsSystemUser("unauthorizedUser");
        }
      })
      .catch((e) => {
        setIsSystemUser("networkErr");
      });
  };

  useEffect(() => {
    if (localStorage.getItem("token") && !isSystemUser) {
      checkUser();
    }
  }, [localStorage.getItem("token")]);

  if (initialized && keycloak.authenticated) {
    if (isSystemUser == "systemUser") {
      return (
        <ThemeContextProvider user={user}>
          <Markup />
        </ThemeContextProvider>
      );
    } else if (isSystemUser == "unauthorizedUser") {
      return <LoginErrorPage />;
    } else if (isSystemUser == "networkErr") {
      return <NetworkError />;
    } else {
      return <Spinner className={"spinner-none"} animation="border" />;
    }
  } else {
    return <div></div>;
  }
};

export default withResizeDetector(App);
